import { Component, inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { UtcDateWithoutTimeZonePipe } from "@mynexus/mynexus-ui-lib";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'hh-care-acception-dialog',
  templateUrl: './hh-care-acception-dialog.component.html',
  styleUrls: ['./hh-care-acception-dialog.component.scss'],
  standalone: false
})
export class HHCareAcceptionDialogDialogComponent implements OnInit {
  careAcceptionForm: FormGroup;

  private readonly ref = inject(DynamicDialogRef);

  get isAcceptingCare(): FormControl {
    return this.careAcceptionForm?.get('isAcceptingCare') as FormControl;
  } 

  ngOnInit(): void {
    this.careAcceptionForm = new FormGroup({
      isAcceptingCare: new FormControl(null, Validators.required),
      pacAnticipatingDischargeDate: new FormControl(null),
    });
  }

  confirm() {
    const { isAcceptingCare, pacAnticipatingDischargeDate } = this.careAcceptionForm.value;
    const date = pacAnticipatingDischargeDate ?
      new UtcDateWithoutTimeZonePipe('en-US').transform(pacAnticipatingDischargeDate.toString(), 'yyyy-MM-dd')
      : null;

    this.ref.close({isAcceptingCare, pacAnticipatingDischargeDate: date});
  }

  cancel() {
    this.ref.close();
  }
}